export default __webpack_public_path__ + "static/logo_b-dd3ab1df0e08e1d9aa642b1fd8b0cf86.svg";